import {Component, OnInit} from '@angular/core';
import {Item, ItemData, SectionData} from './catalog-manager/catalog-manager.models';
import {ModelProvider} from "../../../../framework/providers/modelProvider/ModelProvider";
import {Events} from "../../../../framework/providers/events";

@Component({
    selector: 'app-catalog-admin',
    templateUrl: './catalog-admin.page.html',
    styleUrls: ['./catalog-admin.page.scss'],
})
export class CatalogAdminPage implements OnInit {
    catalogData: any;
    isLoading: boolean = true;
    //     : CatalogData = {
    //     items: {},
    //     sections: {},
    //     itemToSections: {}
    // };

    constructor(private modelProvider: ModelProvider, public events:Events) {

    }


    ngOnInit() {
        this.loadDemoData();

        this.events.subscribe('refresh_catalog', () => {
            this.refresh();
        })
    }

    refresh() {
        this.isLoading = true;
        this.catalogData = null;
        this.loadDemoData();
    }

    loadDemoData() {
        let items: { [key: string]: ItemData } = {};
        let sections: { [key: string]: SectionData } = {};
        let itemToSections: { [key: string]: number[] } = {};
        let me = this;
        this.modelProvider.custom("getCatalogManager").then(function (res) {
            me.catalogData = res;
            me.isLoading = false;
            // res['items'],
            // res['sections'],
            // res['itemToSections'],
            // };
        })
    }

    loadDemoData_1() {
        // Generate 10 top-level sections with 4 levels deep, 5 subsections per level
        let sectionId = 1;
        const sections: { [key: string]: SectionData } = {};

        const topSectionNames = [
            'Electronics', 'Clothing', 'Home & Garden', 'Sports & Outdoors',
            'Books & Media', 'Toys & Games', 'Automotive', 'Health & Beauty',
            'Food & Beverages', 'Office Supplies'
        ];

        const level2Names = ['Category A', 'Category B', 'Category C', 'Category D', 'Category E'];

        // Create 10 top-level sections
        for (let i = 0; i < 10; i++) {
            const topSectionId = sectionId++;
            sections[topSectionId] = {
                id: topSectionId,
                name: topSectionNames[i],
                parentSectionId: null,
                mainImageUrl: 'https://b2c-a872.kxcdn.com/apps/tuner/images/220497_main.webp.thumbnail'
            };

            // Level 2: 5 subsections for each top section
            for (let j = 0; j < 5; j++) {
                const level2Id = sectionId++;
                sections[level2Id] = {
                    id: level2Id,
                    name: `${topSectionNames[i]} - ${level2Names[j]}`,
                    parentSectionId: topSectionId,
                    mainImageUrl: 'https://b2c-a872.kxcdn.com/apps/tuner/images/220497_main.webp.thumbnail'
                };
            }
        }

        console.log(`Generated ${Object.keys(sections).length} sections`);

        // Generate 500+ items distributed across sections
        const items: { [key: string]: ItemData } = {};
        const itemToSections: { [key: string]: number[] } = {};

        const itemPrefixes = [
            'Device', 'Product', 'Item', 'Article', 'Component', 'Module',
            'Unit', 'Part', 'Piece', 'Element', 'Object', 'Asset', 'Tool',
            'Equipment', 'Material', 'Supply', 'Resource', 'Gadget', 'Widget'
        ];

        const adjectives = [
            'Premium', 'Standard', 'Deluxe', 'Professional', 'Basic', 'Advanced',
            'Ultra', 'Super', 'Mega', 'Pro', 'Elite', 'Master', 'Expert', 'Smart',
            'Classic', 'Modern', 'Vintage', 'Digital', 'Analog', 'Wireless'
        ];

        // Get all leaf sections (sections that have no children)
        const allSectionIds = Object.keys(sections).map(k => parseInt(k));
        const leafSections = allSectionIds.filter(secId => {
            const hasChildren = allSectionIds.some(childId => sections[childId].parentSectionId === secId);
            return !hasChildren;
        });

        console.log(`Found ${leafSections.length} leaf sections`);

        // Create 500+ items
        for (let i = 0; i < 500; i++) {
            const prefix = itemPrefixes[i % itemPrefixes.length];
            const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
            const itemNumber = String(i + 1).padStart(4, '0');
            const itemId = i + 1;

            // Assign to 1-3 random leaf sections
            const numSections = Math.floor(Math.random() * 3) + 1;
            const sectionIds: number[] = [];

            for (let j = 0; j < numSections; j++) {
                const randomSection = leafSections[Math.floor(Math.random() * leafSections.length)];
                if (!sectionIds.includes(randomSection)) {
                    sectionIds.push(randomSection);
                }
            }

            items[itemId] = {
                id: itemId,
                name: `${adjective} ${prefix} #${itemNumber}`,
                code: `${prefix.substring(0, 3).toUpperCase()}-${itemNumber}`,
                mainImageUrl: 'https://b2c-a872.kxcdn.com/apps/tuner/images/220497_main.webp.thumbnail',
            images: []
            };

            itemToSections[itemId.toString()] = sectionIds;
        }

        console.log(`Generated ${Object.keys(items).length} items`);

        this.catalogData = {
            items,
            sections,
            itemToSections
        };
    }

    onItemCreated(event: any) {
        console.log('Item created:', event.item);
        const item = event.item;
        this.catalogData.items[item.id.toString()] = {
            id: item.id,
            name: item.name,
            code: item.code,
            mainImageUrl: item.image
        };
        this.catalogData.itemToSections[item.id.toString()] = item.section_ids;
        // Trigger change detection
        this.catalogData = {...this.catalogData};
    }

    onItemUpdated(event: any) {
        console.log('Item updated:', event.item);
        const item = event.item;
        const itemKey = item.id.toString();
        if (this.catalogData.items[itemKey]) {
            this.catalogData.items[itemKey] = {
                id: item.id,
                name: item.name,
                code: item.code,
                mainImageUrl: item.image
            };
            this.catalogData.itemToSections[itemKey] = item.section_ids;
            // Trigger change detection
            this.catalogData = {...this.catalogData};
        }
    }

    onItemMoved(event: any) {
        console.log('Item moved:', event);
        const itemId = event.itemId;
        const itemKey = itemId.toString();
        if (this.catalogData.itemToSections[itemKey]) {
            const currentSections = this.catalogData.itemToSections[itemKey];
            // Remove from source section
            const sectionsAfterRemoval = currentSections.filter(id => id !== event.fromSectionId);
            // Add to target section only if not already present
            if (!sectionsAfterRemoval.includes(event.toSectionId)) {
                this.catalogData.itemToSections[itemKey] = [...sectionsAfterRemoval, event.toSectionId];
            } else {
                this.catalogData.itemToSections[itemKey] = sectionsAfterRemoval;
            }
            // Trigger change detection
            this.catalogData = {...this.catalogData};
        } else {
            // on add from -1 section.
            this.catalogData.itemToSections[itemKey] = [event.toSectionId];
            this.catalogData = {...this.catalogData};
        }
    }

    onSectionCreated(event: any) {
        console.log('Section created:', event.section);
        const section = event.section;
        this.catalogData.sections[section.id.toString()] = {
            id: section.id,
            name: section.name,
            parentSectionId: section.top_sec_id,
            mainImageUrl: section.image
        };
        // Trigger change detection
        this.catalogData = {...this.catalogData};
    }

    onSectionUpdated(event: any) {
        console.log('Section updated:', event.section);
        const section = event.section;
        const sectionKey = section.id.toString();
        if (this.catalogData.sections[sectionKey]) {
            this.catalogData.sections[sectionKey] = {
                id: section.id,
                name: section.name,
                parentSectionId: section.top_sec_id,
                mainImageUrl: section.image
            };
            // Trigger change detection
            this.catalogData = {...this.catalogData};
        }
    }

    onSectionDeleted(event: any) {
        console.log('Section deleted:', event.sectionId);
        delete this.catalogData.sections[event.sectionId.toString()];
        // Trigger change detection
        this.catalogData = {...this.catalogData};
    }

    onChangesSaved(event: any) {
        console.log('Changes saved:', event.data);
        // Here you could persist the changes to a backend or local storage
        // For now, just log them
        console.log('Data structure:', JSON.stringify(event.data, null, 2));

        this.modelProvider.customPost('getCatalogManager', event.data).then(function (res) {
            console.log('post saved');
        });
    }
}
